// extracted by mini-css-extract-plugin
module.exports = {"root":"DownloadSummarySlot_root__233uB"};